package at.theatervogelweide.domain

import kotlinx.datetime.LocalDateTime

/** Whether a news item is shown on the public site, depending on its `activeFrom` and `activeTo`. */
enum class NewsVisibility(val label: String) {
    PUBLIC("Öffentlich"),
    PLANNED("Geplant"),
    EXPIRED("Abgelaufen"),
    ;

    companion object {

        /**
         * A news item is shown from [activeFrom] (inclusive) until [activeTo] (exclusive), without either it is shown
         * from or until forever. All timestamps are in UTC, as stored in the database.
         */
        fun of(activeFrom: LocalDateTime?, activeTo: LocalDateTime?, now: LocalDateTime): NewsVisibility {
            return when {
                activeFrom != null && activeFrom > now -> PLANNED
                activeTo != null && activeTo <= now -> EXPIRED
                else -> PUBLIC
            }
        }
    }
}
